// Kept apart from the policy checks so the composables (browser bundle) can export them without Node-only code
export const PASSWORD_MIN_LENGTH = 14;

export const PASSWORD_POLICY_MESSAGES = {
  tooShort: `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`,
  breached:
    'This password has appeared in a data breach and is unsafe to use. Please choose a different password',
  reused: 'Your new password must be different from your current password',
};
